import React, { type FC } from 'react'
import { RouterProvider } from 'react-router'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import { useAppContext } from './contexts/App.context'
import { createRouter } from './router'

export const App: FC = () => {
  const { basePath } = useAppContext()
  const router = React.useMemo(() => createRouter(basePath), [basePath])

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  )
}
